import { FC, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

const PageContent: FC<Props> = ({ children }) => {
    return (
        <div className="pageContent">
            {children}
        </div>
    );
};

export default PageContent;
